export const INSTAGRAM_STANDARD_REPLY_WINDOW_MS = 24 * 60 * 60 * 1000;

export type InstagramReplyWindowStatus =
  | { kind: 'not-applicable'; remainingMs: null }
  | { kind: 'unknown'; remainingMs: null }
  | { kind: 'open'; remainingMs: number }
  | { kind: 'blocked'; remainingMs: 0 };

export function isInstagramChannel(platform?: string | null): boolean {
  // Threads created before the channel field was exposed are Instagram threads.
  return !platform || platform.toLowerCase() === 'instagram';
}

export function getInstagramReplyWindowStatus(
  replyWindowEndsAt?: string | null,
  platform?: string | null,
  nowMs = Date.now(),
): InstagramReplyWindowStatus {
  if (!isInstagramChannel(platform)) {
    return { kind: 'not-applicable', remainingMs: null };
  }

  const deadlineMs = Date.parse(replyWindowEndsAt || '');
  if (!Number.isFinite(deadlineMs)) {
    return { kind: 'unknown', remainingMs: null };
  }

  const remainingMs = deadlineMs - nowMs;
  if (remainingMs <= 0) {
    return { kind: 'blocked', remainingMs: 0 };
  }

  return { kind: 'open', remainingMs };
}

export function replyWindowEndsAtFromInbound(
  inboundMessageAt?: string | null,
): string | null {
  const inboundMs = Date.parse(inboundMessageAt || '');
  if (!Number.isFinite(inboundMs)) return null;
  return new Date(inboundMs + INSTAGRAM_STANDARD_REPLY_WINDOW_MS).toISOString();
}

export function formatReplyWindowCountdown(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, '0'))
    .join(':');
}
